var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUpload = function SvgIconUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.158,
    height: 34,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.579 0A12.4 12.4 0 0 0 8.332 10.08a10.262 10.262 0 0 0 1.957 20.341h4.921a1.342 1.342 0 1 0 0-2.684h-4.92a7.608 7.608 0 0 1-.7-15.183 1.342 1.342 0 0 0 1.2-1.174 9.848 9.848 0 1 1 19.559 2.32 1.342 1.342 0 0 0 1.328 1.51h.531a6.263 6.263 0 0 1 0 12.527h-6.261a1.342 1.342 0 1 0 0 2.684h6.263a8.923 8.923 0 0 0 .811-17.811A12.388 12.388 0 0 0 20.579.001Zm0 16.105a1.2 1.2 0 0 0-.909.35l-4.921 4.474a1.354 1.354 0 0 0-.084 1.9 1.4 1.4 0 0 0 1.9.084l2.67-2.433v12.178a1.342 1.342 0 1 0 2.684 0V20.481l2.67 2.433a1.434 1.434 0 0 0 1.9-.084 1.351 1.351 0 0 0-.084-1.9l-4.921-4.474a1.132 1.132 0 0 0-.905-.351Z",
    fill: "#0082ed"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_upload.cd99484a.svg";
export { ForwardRef as ReactComponent };